import { type FC } from 'react';
import cx from 'classnames';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import type { UsageReportWeeklyTrend } from 'src/graphql/reports/queryUsageReportDashboard';

import { ChartTooltip } from '../ChartTooltip';

import { useStyles } from './useStyles';

interface TemplateUsageChartProps {
  className?: string;
  data: UsageReportWeeklyTrend[];
}

export const TemplateUsageChart: FC<TemplateUsageChartProps> = ({ className, data }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.title}>Saved Template Generations</div>
      <ResponsiveContainer
        width="100%"
        height="90%"
      >
        <BarChart
          data={data}
          margin={{ top: 10, right: 15, left: 0, bottom: 5 }}
        >
          <CartesianGrid
            vertical={false}
            strokeDasharray="3 3"
          />
          <XAxis
            dataKey="week"
            tickLine={false}
            tickFormatter={(v) => {
              if (!v) return '';
              const d = new Date(v);
              return `${d.getMonth() + 1}/${d.getDate()}`;
            }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tickCount={5}
            width={40}
          />
          <Tooltip content={<ChartTooltip />} />
          <Legend
            align="left"
            verticalAlign="bottom"
            iconType="rect"
          />
          <Bar
            name="Template Generations"
            dataKey="savedTemplateGenerationsCount"
            fill="#3D7FFE"
            fillOpacity={0.8}
            radius={[4, 4, 0, 0]}
            isAnimationActive={false}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
